import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import arAccount from './assets/locales/ar/account.json';
import arCampaign from './assets/locales/ar/campaign .json';
import arCustomDate from './assets/locales/ar/customdate.json';
import arDashboard from './assets/locales/ar/dashboard.json';
import arDeviceHub from './assets/locales/ar/devicehub.json';
import arDevices from './assets/locales/ar/devices.json';
import arDynamicPricing from './assets/locales/ar/dynamicPricing.json';
import arEndConsumer from './assets/locales/ar/endConsumer.json';
import arFilters from './assets/locales/ar/filters.json';
import arGuestCharging from './assets/locales/ar/guestCharging.json';
import arInvoice from './assets/locales/ar/invoice.json';
import arLocation from './assets/locales/ar/location.json';
import arLogin from './assets/locales/ar/login.json';
import arLoginV2 from './assets/locales/ar/loginV2.json';
import arMaintenanceSchedule from './assets/locales/ar/maintenanceSchedule.json';
import arOcpi from './assets/locales/ar/ocpi.json';
import arPartnerDeviceManagement from './assets/locales/ar/partner/deviceManagement.json';
import arPartnerFacilityManagement from './assets/locales/ar/partner/facilityManagement.json';
import arPartnerTableSidePanel from './assets/locales/ar/partner/tableSidePanel.json';
// import arPartnerDeviceManagement from './assets/locales/ar/partnerDeviceManagement.json';
import arPaymentGateway from './assets/locales/ar/paymentGateway.json';
import arPenaltyManagement from './assets/locales/ar/penaltyManagement.json';
import arPricing from './assets/locales/ar/pricing.json';
import arProfile from './assets/locales/ar/profile.json';
import arqrCode from './assets/locales/ar/qrCode.json';
import arReport from './assets/locales/ar/report.json';
import arRevenue from './assets/locales/ar/revenue.json';
import arSetting from './assets/locales/ar/setting.json';
import arSharedComp from './assets/locales/ar/sharedComp.json';
import arSharedComponent from './assets/locales/ar/sharedComponent.json';
import arSidePanel from './assets/locales/ar/sidePanel.json';
import arStation from './assets/locales/ar/station.json';
import arStripePayout from './assets/locales/ar/stripePayout.json';
import arTariff from './assets/locales/ar/tariff.json';
import arTransaction from './assets/locales/ar/transaction.json';
import arUserRole from './assets/locales/ar/userRole.json';
import arVLBC from './assets/locales/ar/vlbc.json';
import enAccount from './assets/locales/en/account.json';
import enCampaign from './assets/locales/en/campaign .json';
import enCustomDate from './assets/locales/en/customdate.json';
import enDashboard from './assets/locales/en/dashboard.json';
import enDeviceHub from './assets/locales/en/devicehub.json';
import enDevices from './assets/locales/en/devices.json';
import enDynamicPricing from './assets/locales/en/dynamicPricing.json';
import enEndConsumer from './assets/locales/en/endConsumer.json';
import enFilters from './assets/locales/en/filters.json';
import enGuestCharging from './assets/locales/en/guestCharging.json';
import enInvoice from './assets/locales/en/invoice.json';
import enLocation from './assets/locales/en/location.json';
import enLogin from './assets/locales/en/login.json';
import enLoginV2 from './assets/locales/en/loginV2.json';
import enMaintenanceSchedule from './assets/locales/en/maintenanceSchedule.json';
import enOcpi from './assets/locales/en/ocpi.json';
import enPartnerDeviceManagement from './assets/locales/en/partner/deviceManagement.json';
import enPartnerFacilityManagement from './assets/locales/en/partner/facilityManagement.json';
import enPartnerTableSidePanel from './assets/locales/en/partner/tableSidePanel.json';
import enPaymentGateway from './assets/locales/en/paymentGateway.json';
import enPenaltyManagement from './assets/locales/en/penaltyManagement.json';
import enPricing from './assets/locales/en/pricing.json';
import enProfile from './assets/locales/en/profile.json';
import enqrCode from './assets/locales/en/qrCode.json';
import enReport from './assets/locales/en/report.json';
import enRevenue from './assets/locales/en/revenue.json';
import enSetting from './assets/locales/en/setting.json';
import enSharedComp from './assets/locales/en/sharedComp.json';
import enSharedComponent from './assets/locales/en/sharedComponent.json';
import enSidePanel from './assets/locales/en/sidePanel.json';
import enStation from './assets/locales/en/station.json';
import enStripePayout from './assets/locales/en/stripePayout.json';
import enTariff from './assets/locales/en/tariff.json';
import enTransaction from './assets/locales/en/transaction.json';
import enUserRole from './assets/locales/en/userRole.json';
import enVLBC from './assets/locales/en/vlbc.json';
import frAccount from './assets/locales/fr/account.json';
import frCampaign from './assets/locales/fr/campaign .json';
import frCustomDate from './assets/locales/fr/customdate.json';
import frDashboard from './assets/locales/fr/dashboard.json';
import frDeviceHub from './assets/locales/fr/devicehub.json';
import frDevices from './assets/locales/fr/devices.json';
import frDynamicPricing from './assets/locales/fr/dynamicPricing.json';
import frEndConsumer from './assets/locales/fr/endConsumer.json';
import frFilters from './assets/locales/fr/filters.json';
import frGuestCharging from './assets/locales/fr/guestCharging.json';
import frInvoice from './assets/locales/fr/invoice.json';
import frLocation from './assets/locales/fr/location.json';
import frLogin from './assets/locales/fr/login.json';
import frLoginV2 from './assets/locales/fr/loginV2.json';
import frMaintenanceSchedule from './assets/locales/fr/maintenanceSchedule.json';
import frOcpi from './assets/locales/fr/ocpi.json';
import frPartnerDeviceManagement from './assets/locales/fr/partner/deviceManagement.json';
import frPartnerFacilityManagement from './assets/locales/fr/partner/facilityManagement.json';
import frPartnerTableSidePanel from './assets/locales/fr/partner/tableSidePanel.json';
import frPaymentGateway from './assets/locales/fr/paymentGateway.json';
import frPenaltyManagement from './assets/locales/fr/penaltyManagement.json';
import frPricing from './assets/locales/fr/pricing.json';
import frProfile from './assets/locales/fr/profile.json';
import frqrCode from './assets/locales/fr/qrCode.json';
import frReport from './assets/locales/fr/report.json';
import frRevenue from './assets/locales/fr/revenue.json';
import frSetting from './assets/locales/fr/setting.json';
import frSharedComp from './assets/locales/fr/sharedComp.json';
import frSharedComponent from './assets/locales/fr/sharedComponent.json';
import frSidePanel from './assets/locales/fr/sidePanel.json';
import frStation from './assets/locales/fr/station.json';
import frStripePayout from './assets/locales/fr/stripePayout.json';
import frTariff from './assets/locales/fr/tariff.json';
import frTransaction from './assets/locales/fr/transaction.json';
import frUserRole from './assets/locales/fr/userRole.json';
import frVLBC from './assets/locales/fr/vlbc.json';
import spAccount from './assets/locales/sp/account.json';
import spCampaign from './assets/locales/sp/campaign.json';
import spCustomDate from './assets/locales/sp/customdate.json';
import spDashboard from './assets/locales/sp/dashboard.json';
import spDeviceHub from './assets/locales/sp/devicehub.json';
import spDevices from './assets/locales/sp/devices.json';
import spDynamicPricing from './assets/locales/sp/dynamicPricing.json';
import spEndConsumer from './assets/locales/sp/endConsumer.json';
import spFilters from './assets/locales/sp/filters.json';
import spGuestCharging from './assets/locales/sp/guestCharging.json';
import spInvoice from './assets/locales/sp/invoice.json';
import spLocation from './assets/locales/sp/location.json';
import spLogin from './assets/locales/sp/login.json';
import spLoginV2 from './assets/locales/sp/loginV2.json';
import spMaintenanceSchedule from './assets/locales/sp/maintenanceSchedule.json';
import spOcpi from './assets/locales/sp/ocpi.json';
import spPartnerDeviceManagement from './assets/locales/sp/partner/deviceManagement.json';
import spPartnerFacilityManagement from './assets/locales/sp/partner/facilityManagement.json';
import spPartnerTableSidePanel from './assets/locales/sp/partner/tableSidePanel.json';
import spPaymentGateway from './assets/locales/sp/paymentGateway.json';
import spPenaltyManagement from './assets/locales/sp/penaltyManagement.json';
import spPricing from './assets/locales/sp/pricing.json';
import spProfile from './assets/locales/sp/profile.json';
import spqrCode from './assets/locales/sp/qrCode.json';
import spReport from './assets/locales/sp/report.json';
import spRevenue from './assets/locales/sp/revenue.json';
import spSetting from './assets/locales/sp/setting.json';
import spSharedComp from './assets/locales/sp/sharedComp.json';
import spSharedComponent from './assets/locales/sp/sharedComponent.json';
import spSidePanel from './assets/locales/sp/sidePanel.json';
import spStation from './assets/locales/sp/station.json';
import spStripePayout from './assets/locales/sp/stripePayout.json';
import spTariff from './assets/locales/sp/tariff.json';
import spTransaction from './assets/locales/sp/transaction.json';
import spUserRole from './assets/locales/sp/userRole.json';
import spVLBC from './assets/locales/sp/vlbc.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        login: enLogin,
        profile: enProfile,
        location: enLocation,
        station: enStation,
        dashboard: enDashboard,
        account: enAccount,
        pricing: enPricing,
        userRole: enUserRole,
        endConsumer: enEndConsumer,
        transaction: enTransaction,
        revenue: enRevenue,
        stripePayout: enStripePayout,
        campaign: enCampaign,
        guestCharging: enGuestCharging,
        qrCode: enqrCode,
        report: enReport,
        devices: enDevices,
        sidePanel: enSidePanel,
        sharedComp: enSharedComp,
        sharedComponent: enSharedComponent,
        penaltyManagement: enPenaltyManagement,
        customDate: enCustomDate,
        loginV2: enLoginV2,
        vlbc: enVLBC,
        dynamicPricing: enDynamicPricing,
        maintenanceSchedule: enMaintenanceSchedule,
        partnerDeviceManagement: enPartnerDeviceManagement,
        partnerFacilityManagement: enPartnerFacilityManagement,
        facilityManagement: enPartnerFacilityManagement,
        partnerTableSidePanel: enPartnerTableSidePanel,
        setting: enSetting,
        ocpi: enOcpi,
        invoice: enInvoice,
        deviceHub: enDeviceHub,
        paymentGateway: enPaymentGateway,
        tariff: enTariff,
        filters: enFilters,
      },
      ar: {
        login: arLogin,
        location: arLocation,
        station: arStation,
        dashboard: arDashboard,
        account: arAccount,
        pricing: arPricing,
        guestCharging: arGuestCharging,
        userRole: arUserRole,
        endConsumer: arEndConsumer,
        transaction: arTransaction,
        revenue: arRevenue,
        profile: arProfile,
        stripePayout: arStripePayout,
        campaign: arCampaign,
        qrCode: arqrCode,
        report: arReport,
        devices: arDevices,
        sidePanel: arSidePanel,
        sharedComp: arSharedComp,
        sharedComponent: arSharedComponent,
        penaltyManagement: arPenaltyManagement,
        customDate: arCustomDate,
        loginV2: arLoginV2,
        vlbc: arVLBC,
        dynamicPricing: arDynamicPricing,
        maintenanceSchedule: arMaintenanceSchedule,
        partnerDeviceManagement: arPartnerDeviceManagement,
        partnerFacilityManagement: arPartnerFacilityManagement,
        facilityManagement: arPartnerFacilityManagement,
        partnerTableSidePanel: arPartnerTableSidePanel,
        setting: arSetting,
        ocpi: arOcpi,
        invoice: arInvoice,
        deviceHub: arDeviceHub,
        paymentGateway: arPaymentGateway,
        tariff: arTariff,
        filters: arFilters,
      },
      fr: {
        login: frLogin,
        location: frLocation,
        station: frStation,
        dashboard: frDashboard,
        account: frAccount,
        pricing: frPricing,
        guestCharging: frGuestCharging,
        userRole: frUserRole,
        endConsumer: frEndConsumer,
        transaction: frTransaction,
        revenue: frRevenue,
        stripePayout: frStripePayout,
        campaign: frCampaign,
        qrCode: frqrCode,
        report: frReport,
        devices: frDevices,
        sidePanel: frSidePanel,
        sharedComp: frSharedComp,
        sharedComponent: frSharedComponent,
        penaltyManagement: frPenaltyManagement,
        customDate: frCustomDate,
        loginV2: frLoginV2,
        vlbc: frVLBC,
        dynamicPricing: frDynamicPricing,
        maintenanceSchedule: frMaintenanceSchedule,
        partnerDeviceManagement: frPartnerDeviceManagement,
        partnerFacilityManagement: frPartnerFacilityManagement,
        facilityManagement: frPartnerFacilityManagement,
        partnerTableSidePanel: frPartnerTableSidePanel,
        setting: frSetting,
        profile: frProfile,
        ocpi: frOcpi,
        invoice: frInvoice,
        deviceHub: frDeviceHub,
        paymentGateway: frPaymentGateway,
        tariff: frTariff,
        filters: frFilters,
      },
      sp: {
        login: spLogin,
        location: spLocation,
        station: spStation,
        dashboard: spDashboard,
        account: spAccount,
        pricing: spPricing,
        guestCharging: spGuestCharging,
        userRole: spUserRole,
        endConsumer: spEndConsumer,
        transaction: spTransaction,
        revenue: spRevenue,
        stripePayout: spStripePayout,
        campaign: spCampaign,
        qrCode: spqrCode,
        report: spReport,
        devices: spDevices,
        sidePanel: spSidePanel,
        sharedComp: spSharedComp,
        sharedComponent: spSharedComponent,
        penaltyManagement: spPenaltyManagement,
        customDate: spCustomDate,
        loginV2: spLoginV2,
        vlbc: spVLBC,
        dynamicPricing: spDynamicPricing,
        maintenanceSchedule: spMaintenanceSchedule,
        partnerDeviceManagement: spPartnerDeviceManagement,
        partnerFacilityManagement: spPartnerFacilityManagement,
        facilityManagement: spPartnerFacilityManagement,
        partnerTableSidePanel: spPartnerTableSidePanel,
        setting: spSetting,
        profile: spProfile,
        ocpi: spOcpi,
        invoice: spInvoice,
        deviceHub: spDeviceHub,
        paymentGateway: spPaymentGateway,
        tariff: spTariff,
        filters: spFilters,
      },
    },
    supportedLngs: ['en', 'ar', 'fr', 'sp'],
    fallbackLng: 'en',
    detection: {
      order: [
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
    },
    ns: [
      'login',
      'dashboard',
      'account',
      'station',
      'location',
      'guestCharging',
      'pricing',
      'userRole',
      'endConsumer',
      'transaction',
      'revenue',
      'stripePayout',
      'campaign',
      'qrCode',
      'devices',
      'sidePanel',
      'sharedComp',
      'sharedComponent',
      'customDate',
      'loginV2',
      'vlbc',
      'partnerDeviceManagement',
      'partnerFacilityManagement',
      'facilityManagement',
      'partnerTableSidePanel',
      'setting',
      'profile',
      'ocpi',
      'deviceHub',
      'paymentGateway',
      'tariff',
      'filters',
    ],
    defaultNS: 'login',
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
  });

/**
 * Updates document direction attribute based on current language.
 * @param {string} language - The language code to apply direction for.
 */
const updateDocumentDirection = (language: string): void => {
  const direction = language === 'ar' ? 'rtl' : 'ltr';
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('dir', direction);
    document.body.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', language);
  }
};

i18n.on('languageChanged', (lng: string) => {
  updateDocumentDirection(lng);
});

updateDocumentDirection(i18n.language || 'en');

export default i18n;
